import { Grid } from "@material-ui/core";
import { useCallback, useEffect } from "react";
import { Text } from "sunrise-ui";

// ------for table--------------
import NoDataScreen from "../../utilities/NoDataScreen";
import { AppDispatch } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { getCompletedProjectData } from "../../redux/reducers/projectReducers";
import List from "../../utilities/List";

const CompletedProjects = () => {
  const dispatch = useDispatch<AppDispatch>();
  const completedProjectData = useSelector(
    (state: any) => state.PROJECT.completedProjectData
  );
  const getData = useCallback(() => {
    dispatch(getCompletedProjectData({ endPoint: `project/completed` }));
  }, [dispatch]);

  useEffect(() => {
    getData();
  }, [getData]);

  const fields = [
    {
      header: "Project Name",
      search: true,
      value: "projectName",
    },
    {
      header: "Project Start Date",
      search: true,
      value: "startDate",
    },
    {
      header: "Project Completion Date",
      value: "endDate",
      search: true,
    },
    {
      header: "Total Expense",
      value: "totalExpense",
      search: true,
    },
    {
      header: "Total Revenue",
      value: "totalRevenue",
      search: true,
    },
    {
      header: "Duration",
      search: true,
      value: "duration",
    },
  ];

  return (
    <Grid container>
      {/* ----------------total project box----------------- */}
      <Grid className="total_box bg--white box--shadow mt1 mb d-flex v-center">
        <Grid className="icon_container running_icon">
          <span className="iconify" data-icon="mdi:progress-clock"></span>
        </Grid>
        <Text
          type="normal"
          fonts="normal"
          fontSize={18}
          className="mb0 mt0 fw400"
        >
          Total Completed Projects: {completedProjectData?.length}
        </Text>
      </Grid>
      <Grid item xs={12}>
        {completedProjectData.length > 0 ? (
          <List
            listData={completedProjectData}
            fields={fields}
            title={"Completed Projects Details"}
          />
        ) : (
          <NoDataScreen text="There are no data available for Completed Projects." />
        )}
      </Grid>
    </Grid>
  );
};

export default CompletedProjects;
